/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 2194421430@qq.com
 * @Date: 2021-04-19 12:05:04
 * @LastEditors: sj
 * @LastEditTime: 2022-06-20 16:45:40
 */
import { Button, Col, Form, Modal, Row, Select, Space, Table, Tabs } from "antd"
import React, { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { NavBar } from "../../../compnents/nav/NavBar"
import { RootDispatch } from "../../../app/store"
import axios from "axios"
import { useLocation } from "react-router-dom"
import styles from "../filing.module.css"
import { PreviewImgOrPdf } from "../Preview"
import { getSJWHTokenAsync } from "../../dataMaintenance/organization/data"
import { unwrapResult } from "@reduxjs/toolkit"
import { AXIOS_IP, exportPdf } from "../fileUploadService"

export const TcmSpecialDetail = () => {
  const { TabPane } = Tabs

  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const [baseUrl, setBaseUrl] = useState("")

  const [detail, setDetail] = useState<any>({})

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const [token, setToken] = useState("")

  const [exportPdfLoading, setExportPdfLoading] = useState(false)

  const getData = () => {
    dispatch(getSJWHTokenAsync())
      .then(unwrapResult)
      .then((token: any) => {
        setToken(token)
        axios({
          url:
            location.state?.state == 1
              ? `${AXIOS_IP}/filingFeature/detail`
              : `${AXIOS_IP}/filingReviewFeature/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": token,
          },
          withCredentials: false,
          method: "POST",
          data: { id: location.state?.id },
        }).then((res) => {
          const data = res.data.data
          const filterData = {
            ...data,
            applicantFile: data?.applicantFile || [],
          }
          setDetail(filterData)
        })
      })
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      <Col>
        <NavBar
          where={["备案管理", "中医特色疗法详情"]}
          backtrace={{
            name: "备案管理",
            path: "/filingManagement",
            state: { fillingType: location.state?.type },
          }}
          buttons={
            location.state?.state == 1 ? (
              [
                <Button
                  key="0"
                  type="primary"
                  loading={exportPdfLoading}
                  onClick={() =>
                    exportPdf({
                      data: { id: location.state?.id },
                      token,
                      path: "/filingFeature/generatePdf",
                      fileName: "中医特色疗法详情.pdf",
                      callback: setExportPdfLoading,
                    })
                  }
                >
                  导出
                </Button>,
              ]
            ) : (
              <></>
            )
          }
        />
      </Col>
      <div
        style={{
          height: "calc(100% - 20px)",
          overflow: "auto",
          margin: "10px 0px",
          padding: "20px",
          background: "#fff",
          borderRadius: "10px",
          position: "relative",
        }}
      >
        <Form
          form={form}
          labelCol={{ span: 3 }}
          wrapperCol={{ span: 20 }}
          //   colon={false}
        >
          <Row
            style={{
              fontWeight: "bold",
              fontSize: "17px",
              paddingLeft: "15px",
              paddingBottom: "30px",
            }}
          >
            中医特色疗法详情
          </Row>
          <Form.Item label="项目名称" name="projectName" rules={[{ required: true }]}>{detail?.projectName}</Form.Item>
          <Form.Item label="项目类型" name="projectTypeName" rules={[{ required: true }]}>{detail?.projectTypeName}</Form.Item>
          <Form.Item label="适应范围" name="adaptationScope" rules={[{ required: true }]}>{detail?.adaptationScope}</Form.Item>
          <Form.Item label="使用禁忌" name="usageContraindications" rules={[{ required: true }]}>
            {detail?.usageContraindications}
          </Form.Item>
          <Form.Item label="应用规范" name="specification" rules={[{ required: true }]}>{detail?.specification}</Form.Item>
          <Form.Item label="传承年数" name="yearsOfInheritance" rules={[{ required: true }]}>{detail?.yearsOfInheritance}</Form.Item>
          <Form.Item label="传承代数" name="algebrasOfInheritance" rules={[{ required: true }]}>
            {detail?.algebrasOfInheritance}
          </Form.Item>
          <Form.Item label="传承脉络" name="contextOfInheritance" rules={[{ required: true }]}>{detail?.contextOfInheritance}</Form.Item>
          <Form.Item label="申报表" name="applicantFile" rules={[{ required: true }]}>
            {detail?.applicantFile?.map((v: any) => {
              return (
                <span key={v.filePath}>
                  {v.fileName}{" "}
                  <a
                    style={{ color: "#0076FF", paddingLeft: "20px" }}
                    onClick={() => setPreviewFile(v)}
                  >
                    查看
                  </a>
                </span>
              )
            })}
          </Form.Item>
        </Form>
      </div>

      <PreviewImgOrPdf
        token={token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
